/**
 * Генерация случайной строки из заданных символов
 * @param {number} minLength - минимальная длина
 * @param {number} maxLength - максимальная длина
 * @param {string} chars - допустимые символы
 * @returns {string} - сгенерированная строка
 */
function generateRandomString(
  minLength: number,
  maxLength: number,
  chars: string
) {
  const length =
    Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
  let result = '';
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * Генерация code_verifier (43-128 символов: a-z, A-Z, 0-9, _, -)
 * @returns {string}
 */
function generateCodeVerifier() {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-';
  return generateRandomString(43, 128, chars);
}

/**
 * Генерация code_challenge (SHA-256 + base64url)
 * @param {string} codeVerifier
 * @returns {Promise<string>}
 */
async function generateCodeChallenge(codeVerifier: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashBase64 = btoa(String.fromCharCode(...hashArray));

  return hashBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
// Константа для code_challenge_method
export const CODE_CHALLENGE_METHOD = 'S256';

/**
 * Генерация state (24-48 символов: a-z, A-Z, 0-9, _, -)
 * @returns {string}
 */
function generateState() {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-';
  return generateRandomString(24, 48, chars);
}

/**
 * Генерация всех переменных для PKCE (асинхронная)
 * @returns {Promise<{ code_verifier: string, code_challenge: string, code_challenge_method: string, state: string }>}
 */
export async function generatePKCE() {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  const state = generateState();

  return {
    codeVerifier,
    codeChallenge,
    codeChallengeMethod: CODE_CHALLENGE_METHOD,
    state,
  };
}
